import React, { useState, useEffect, useRef } from 'react';
import Dashheader from '../Dash-header/Dashheader';
import Sidebar from '../dashboard/Sidebar';
import axios from 'axios';
import { END_URL } from "../../config";
import '../contact/contactPage.css';
import UserFooter from '../footer/UserFooter.jsx';

function Contact({isLoggedIn}) {
    const fileInputRef = useRef(null);
    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        subject: '',
        message: '',
    });


    const [validationErrors, setValidationErrors] = useState({});
    const [modalMessage, setModalMessage] = useState('');
    const [modalVisible, setModalVisible] = useState(false);

    // New state for contact content
    const [contactContent, setContactContent] = useState(null);
    const [loadingContent, setLoadingContent] = useState(true);
    const [contentError, setContentError] = useState('');


    const [caseNumber, setCaseNumber] = useState('');

    const [formSumit, setformSumit] = useState(false);


    // Fetch contact content on mount
    useEffect(() => {
        const fetchContactContent = async () => {
            try {
                const response = await axios.get(`${END_URL}contactcontent`);
                if (response.data && response.data.status) {
                    setContactContent(response.data.data);
                } else {
                    setContentError('Failed to load contact content.');
                }
            } catch (error) {
                setContentError('Failed to load contact content.');
            } finally {
                setLoadingContent(false);
            }
        };
        fetchContactContent();
    }, []);


    useEffect(() => {
 
        fetchCaseCount();
    }, []);

    const fetchCaseCount = async () => {
        try {
            const response = await axios.get(`${END_URL}contact/casecount`);
            if (response.data && typeof response.data.count === 'number') {
                const count = response.data.count + 1;
                const year = new Date().getFullYear();
                const formattedCount = count.toString().padStart(4, '0');
                setCaseNumber(`CCL-${year}-${formattedCount}`);
            }
        } catch (error) {
            console.error('Failed to fetch case count:', error);
            setCaseNumber('CCL-2025-0001'); // fallback
        }
    };


    // Add this inside your component, above the existing useEffect
    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const token = sessionStorage.getItem('authToken');
                if (!token) return; // Skip if not logged in

                const response = await axios.get(`${END_URL}users`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                const userData = response.data;
                // Prefill form data if user data exists
                setFormData(prev => ({
                    ...prev,
                    first_name: userData.name || userData.first_name || prev.first_name,
                    last_name: userData.lastname || userData.last_name || prev.last_name,
                    email: userData.email || prev.email,
                }));
            } catch (error) {
                console.error('Error fetching user data:', error);
            }
        };
        fetchUserData();
    }, []);




    const handleChange = (e) => {
        const { id, value, type, files } = e.target;
        if (type === "file") {
            setFormData({ ...formData, [id]: files[0] }); // Store the first selected file
        } else {
            setFormData({ ...formData, [id]: value });
        }
        setValidationErrors({ ...validationErrors, [id]: '' });
    };

    const validateForm = () => {
        const errors = {};
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!formData.first_name.trim()) errors.first_name = 'First name is required';
        if (!formData.last_name.trim()) errors.last_name = 'Last name is required';
        if (!formData.email.trim()) {
            errors.email = 'Email is required';
        } else if (!emailRegex.test(formData.email)) {
            errors.email = 'Invalid email address';
        }
        if (!formData.message.trim()) errors.message = 'Message is required';


        if (!formData.subject.trim()) errors.subject = 'Subject is required';

        setValidationErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setformSumit(true);

        const data = new FormData();
        Object.entries(formData).forEach(([key, value]) => {
            if (value !== null && value !== undefined) {
                data.append(key, value);
            }
        });

        try {
            await axios.post(`${END_URL}contact`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            setModalMessage('Message sent successfully!');

            setModalVisible(true);

            setTimeout(() => {
                setModalVisible(false);
            }, 3000);

            setFormData(prev => ({
                ...prev,
                subject: '',
                message: '',
                type: '',
                attachment: null
            }));

            fetchCaseCount();

            setformSumit(false);

            setValidationErrors({});
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        } catch (error) {
            setModalMessage('Failed to send message. Please try again.');
            // setModalVisible(true);
        }
    };


    const [expanded1, setExpanded] = useState(false);
    const token = sessionStorage.getItem('authToken');
    return (
        <div className="dashboard-container full-width">

            <Dashheader />

            <div className={`container ${isLoggedIn  ? '' : 'allow-full-width' }` }>
                
                <div className={`row main-row expanded ${expanded1 ? 'mainmenu' : ''}`}>

                {isLoggedIn && (

                    <div className="col-12 col-sm-12 col-md-3 col-lg-3">
                        <div className="dashboard-side-div">
                            <a href="#" className="expand-btn" onClick={(e) => {
                                e.preventDefault();
                                setExpanded(!expanded1);
                            }}><span></span></a>

                            <Sidebar />

                        </div>
                    </div>

                )}

                    <div className="col-12 col-sm-12 col-md-9 col-lg-9">
                        <main className="content">
                            <div className="contact-form">
                                <div className="dashbord-first">
                                    <h3>Contact Us</h3>
                                    {loadingContent ? (
                                        <p>Loading contact information...</p>
                                    ) : contentError ? (
                                        <p className="text-danger">{contentError}</p>
                                    ) : contactContent ? (
                                        <>
                                            <div
                                                dangerouslySetInnerHTML={{ __html: contactContent?.content }}
                                            />
                                        </>
                                    ) : null}
                                </div>
                                <div className="row contact-row">
                                    <div className="col-md-8">
                                        <div className="contact-col1">
                                            <div className="card">
                                                <h3>Send a Message</h3>
                                                <form onSubmit={handleSubmit} noValidate>
                                                    <div className="form-row">
                                                        <div className="form-group col-md-6">
                                                            <label htmlFor="first_name">First Name</label>
                                                            <input type="text" className="form-control" id="first_name" placeholder="First Name" value={formData.first_name} onChange={handleChange} />
                                                            {validationErrors.first_name && <small className="text-danger">{validationErrors.first_name}</small>}
                                                        </div>
                                                        <div className="form-group col-md-6">
                                                            <label htmlFor="last_name">Last Name</label>
                                                            <input type="text" className="form-control" id="last_name" placeholder="Last Name" value={formData.last_name} onChange={handleChange} />
                                                            {validationErrors.last_name && <small className="text-danger">{validationErrors.last_name}</small>}
                                                        </div>
                                                    </div>
                                                    <div className="form-row">
                                                        <div className="form-group col-md-6">
                                                            <label htmlFor="email">Email</label>
                                                            <input type="email" className="form-control" readOnly id="email" placeholder="Email" disabled value={formData.email} onChange={handleChange} />
                                                            {validationErrors.email && <small className="text-danger">{validationErrors.email}</small>}
                                                        </div>

                                                        <div className="form-group col-md-6">
                                                            <label htmlFor="phone_number">Phone Number (Optional)</label>
                                                            <input
                                                                type="tel"
                                                                className="form-control"
                                                                id="phone_number"
                                                                placeholder="Phone Number"
                                                                value={formData.phone_number}
                                                                onChange={handleChange}
                                                            />
                                                            {validationErrors.phone_number && (
                                                                <small className="text-danger">{validationErrors.phone_number}</small>
                                                            )}
                                                        </div>

                                                        <div className="form-group col-md-6">
                                                            <label htmlFor="caseNumber">Case Number</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="caseNumber"
                                                                value={caseNumber}
                                                                readOnly
                                                                disabled
                                                            />
                                                        </div>



                                                    </div>

                                                    <div className="form-group col-md-6">
                                                        <label htmlFor="subject">Query Type</label>
                                                        <select
                                                            className="form-control"
                                                            id="subject"
                                                            value={formData.subject}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select a subject</option>
                                                            <option value="General question">General question</option>
                                                            <option value="Update my information">Update my information</option>
                                                            <option value="I need help submitting documents">Help submitting documents</option>
                                                            <option value="I want to withdraw my registration">Withdraw my registration</option>
                                                            {/* <option value="I want to become a class representative">I want to become a class representative</option>
                                                            <option value="I received a request for more information">I received a request for more information</option>
                                                            <option value="Media/press enquiry">Media/press enquiry</option> */}
                                                            <option value="Other (please specify in message)">Other</option>
                                                        </select>
                                                        {validationErrors.subject && (
                                                            <small className="text-danger">{validationErrors.subject}</small>
                                                        )}
                                                    </div>


                                                    <div className="form-group">
                                                        <label htmlFor="message">Message</label>
                                                        <textarea className="form-control" id="message" rows="5" placeholder="Message" value={formData.message} onChange={handleChange}></textarea>
                                                        {validationErrors.message && <small className="text-danger">{validationErrors.message}</small>}
                                                    </div>


                                                    <div className="form-group col-md-6">
                                                        <label htmlFor="attachment">Attach a File (Optional)</label>
                                                        <input
                                                            type="file"
                                                            className="form-control"
                                                            id="attachment"
                                                            onChange={handleChange}
                                                            accept=".pdf,.doc,.docx,.jpg,.png,.jpeg" // adjust as needed
                                                            ref={fileInputRef}
                                                        />
                                                        {validationErrors.attachment && <small className="text-danger">{validationErrors.attachment}</small>}
                                                    </div>

                                                    <button type="submit" className="btn btn-primary">{!formSumit ? 'Send Message' : 'Sending...'} </button>
                                                </form>

                                                {modalVisible && (

                                                    <div id="saveSuccessAlert" class="saveSuccessAlert" >
                                                        {modalMessage}
                                                    </div>
                                                )}

                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="contact-col1">
                                            <div className="card">
                                                {contactContent && (
                                                    <div className="card-col" dangerouslySetInnerHTML={{ __html: contactContent?.description }} />
                                                )}
                                            </div>
                                            <div className="card">
                                                {contactContent && (
                                                    <div className="card-col" dangerouslySetInnerHTML={{ __html: contactContent?.contactcontent1 }} />
                                                )}
                                                <div className="quick-links">
                                                    <a href="/faqwrapp" className="q-lnk">Frequently Asked Questions</a>
                                                    <a href="/resources" className="q-lnk">View All Resources</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <UserFooter />
                        </main>
                    </div>
                </div>
            </div>

          
        </div>
    );
}

export default Contact;
